const UidispatcherApiModule = await import("uidispatcher_api/UidispatcherApiModule");
export const notify = UidispatcherApiModule.notify;
